import React, { useState, useRef } from 'react';
import TournamentSongCard from './TournamentSongCard';

const MemoTournamentSongCard = React.memo(TournamentSongCard);

export default MemoTournamentSongCard;